"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UpgradeBanner;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const native_base_1 = require("native-base");
const GradientButton_1 = require("../../component/GradientButton");
const AppText_1 = require("../AppText");
const AppIcons_1 = require("../AppIcons");
const colors_1 = require("../../common/colors");
const useDevice_1 = require("../../hooks/useDevice");
const react_redux_1 = require("react-redux");
const rootNavigation_1 = require("../../navigation/rootNavigation");
function UpgradeBanner() {
    const fbUser = (0, react_redux_1.useSelector)((state) => state.getUserOptions.fbUser);
    const isUserLogged = (0, react_1.useMemo)(() => (Boolean(fbUser)), [fbUser]);
    const handleMembershipAction = (0, react_1.useCallback)(() => {
        if (isUserLogged) {
            (0, rootNavigation_1.navigate)('PurchasePlans');
        }
        else {
            (0, rootNavigation_1.navigate)('LoginPage');
        }
    }, [isUserLogged]);
    const { isMobileScreen } = (0, useDevice_1.useDevice)();
    return ((0, jsx_runtime_1.jsxs)(native_base_1.VStack, { style: {
            bottom: 0,
            backgroundColor: colors_1.Colors.DARK_600,
            borderTopRightRadius: 24,
            borderTopLeftRadius: 24,
            height: isMobileScreen ? 220 : 240,
            zIndex: 1,
            paddingTop: isMobileScreen ? 15 : 20,
            paddingHorizontal: isMobileScreen ? 20 : 10,
            alignItems: "center",
            width: "100%",
        }, space: 4, children: [(0, jsx_runtime_1.jsx)(AppIcons_1.SummaraizerLogo, {}), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { color: colors_1.Colors.DARK_100, fontSize: isMobileScreen ? 16 : 14, textAlign: "center", children: "\"Ready to unlock more summaries? Top up your credits to keep the insights flowing!\"" }), (0, jsx_runtime_1.jsx)(GradientButton_1.GradientButton, { text: "Buy More", fullWidth: false, onPress: handleMembershipAction })] }));
}
